/* eslint-disable react/require-default-props */
/* eslint-disable prettier/prettier */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react';
import DataTable from 'react-data-table-component';
import TableLoader from '../../../../components/TableLoader';
import { Container } from './styles';

interface TableProps {
  data: any[];
  columns: any[];
  loading: boolean;
  emptyText: string;
  totalRows?: number
  defaultSortFieldId?: string;
  onChangePage?: any
  onChangeRowsPerPage?: any
}

const EmployeeTable: React.FC<TableProps> = ({
  data,
  loading,
  columns,
  emptyText,
  totalRows,
  onChangePage,
  defaultSortFieldId,
  onChangeRowsPerPage,
}) => {
  console.log({ totalRows, onChangePage, onChangeRowsPerPage });
  return (
    <Container>
      <DataTable
        noHeader
        fixedHeader
        data={data}
        columns={columns}
        progressPending={loading}
        defaultSortFieldId="valorcarga"
        progressComponent={<TableLoader />}
        noDataComponent={emptyText}
      />
    </Container>
  );
};
export default EmployeeTable;
